




























import { Component, Mixins, Ref } from "vue-property-decorator";
import { db, auth, busy, VIPIp } from "@/loader/public";
import IpEdit from "../../component/ip/IpEdit.vue";
import IpView from "../../component/ip/IpView.vue";
import IpNewModal from "../../component/ip/IpNewModal.vue";
import IpTree from "../../component/ip/IpTree.vue";
import { BusyMixin } from "@/mixins/BusyMixin";
import { VIPIpMixin } from "@/mixins/VIPIpMixin";

@Component({
	components: {
		IpEdit,
		IpView,
		IpNewModal,
		IpTree,
	}
})
export default class IPs extends Mixins(VIPIpMixin, BusyMixin) {
	public ip: VIPIp | null = null;

	@Ref()
	public tree!: IpTree;

	@Ref()
	public newModal!: IpNewModal;

	public get couldEdit(): boolean {
		return auth.user?.capabilities.edit_vip_ip || false;
	}

	public get _item(): VIPIp {
		return this.ip;
	}

	public create() {
		if (!this.canCreate) {
			return;
		}
	}

	public select(ip: VIPIp | null) {
		this.ip = ip;
	}

	public removed() {
		this.ip = null;
		this.tree.$forceUpdate();
	}

	public prepareNew() {
		this.newModal.selectParent(this.ip);
	}
}
